import {ApiClientCommunication} from 'neo-common';

export class RealityCheckResponse extends ApiClientCommunication.ResponseBase {
    /**
     * @property messageId - id of client message
     */
    messageId: number;

    /**
     * @property customData - custom data object
     */
    customData: any;

    protected internalValidate(errors: Array<string>): void {
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/RealityCheckResponse.ts
 **/